var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    {
      class: _vm.useIcon
        ? "md-danger md-just-icon md-round"
        : "" + _vm.className,
      attrs: { title: "Delete asset details" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handleDeleteAsset($event)
        },
      },
    },
    [
      _vm.useIcon
        ? _c("md-icon", [_vm._v("delete")])
        : _c("span", [_vm._v("Delete")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }